import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

import common from "./modules/common";
import dashboard from "./modules/dashboard";
import login from "./modules/login";
import signup from "./modules/signup";
import mypage from "./modules/mypage";

const router = new Router({
  mode: "history",
  routes: [...common, ...dashboard, ...login, ...signup, ...mypage],
});

router.beforeEach(async (to, from, next) => {
  let auth = to.meta.auth;

  if (to.path === "/login" && from.path === "/profile") {
    if (store.getters.common.logoutState) {
      store.commit("common/openToast", {
        iconUrl: "/img/simple-modal-treed.svg",
        text: "탈퇴가 완료되었습니다.",
        time: 3000,
      });
    }

    next();
    return;
  }
  // everyone
  if (!auth) {
    next();
    return;
  }

  if (to.name === from.name) {
    next();
    return;
  }

  const token = store.getters.auth.token;
  if (!token) {
    // no token
    // 로그인 페이지 마이그레이션 작업
    // next({ path: "/login" });
    window.location.href = "/login";

    return;
  }

  const code = await store.dispatch("auth/setPageAuth", auth);

  const MESSAGES = {
    TK0001: "로그아웃 되었습니다.",
    TK0003: "중복 로그인으로 인해\n자동으로 로그아웃 되었습니다.",
  };

  if (["TK0001", "TK0003"].includes(code)) {
    store.commit("common/openGlobalModal", {
      content: MESSAGES[code],
      icon: "warn",
    });
    // 로그인 페이지 마이그레이션 작업
    // next({ path: "/login" });
    window.location.href = "/login";

    return;
  }

  const pageAuth = store.getters.auth.pageAuth;
  // have token and have authority
  if (pageAuth.readYn === "Y") {
    next();
    return;
  }

  // 로그인 페이지 마이그레이션 작업
  // next({ path: "/login" });
  window.location.href = "/login";
});

export default router;
